export function NavigateTo(url, history) {
  history.push(url);
}
